import { render, staticRenderFns } from "./PermissionModal.vue?vue&type=template&id=cd013b20&scoped=true&"
import script from "./PermissionModal.vue?vue&type=script&lang=ts&"
export * from "./PermissionModal.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionModal.vue?vue&type=style&index=0&id=cd013b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.7_babel-core@7.0.0-bridge.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.44.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd013b20",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/.pnpm/@quasar+app@2.2.10_lodash@4.17.21/node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
